import PropTypes from 'prop-types';
import leg from './leg';

export default PropTypes.arrayOf(leg);
